import { call, put } from "redux-saga/effects";

import { api, notify, queryBuilder } from "services";
import { requestErrorHandler } from "utils";

import {
  CalendarViewActions,
  CalendarViewRequestAction,
} from "store/ducks/transports/calendar-view";

export function* fetchCalendarViewRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as CalendarViewRequestAction;

    const queryString = queryBuilder(query);
    const { data } = yield call(
      api.get,
      `/transports/calendar-view?${queryString}`
    );

    yield put(CalendarViewActions.success(data));
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CalendarViewActions.failure(errorMessage));
  }
}
